import React, { useCallback, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";

import { toggleLiked, loadDetailPost } from "redux/modules/postSlice";

function LikeToggle({ el, detailPage }) {
  const dispatch = useDispatch();

  const replaceNumber = Number(el.likeCount.replace(/(^0+)/, ""));
  const [likeCount, setLikeCount] = useState(replaceNumber);
  const [isLiked, setIsLiked] = useState(el.isLiked);

  useEffect(() => {
    //console.log(el.isLiked);
    //console.log(replaceNumber);
    //dispatch(loadPost("전체"));
    //dispatch(loadDetailPost(el.boardId));

    setIsLiked(el.isLiked);
    setLikeCount(replaceNumber);
  }, [dispatch, el.isLiked, replaceNumber]);

  const onClickToggleLiked = useCallback(() => {
    setIsLiked(true);
    setLikeCount((prev) => prev + 1);

    dispatch(toggleLiked(el.boardId));
  }, [dispatch, setLikeCount, el]);

  const onClickToggleUnLiked = useCallback(() => {
    setIsLiked(false);
    setLikeCount((prev) => prev - 1);

    dispatch(toggleLiked(el.boardId));
  }, [dispatch, setLikeCount, el]);

  return (
    <>
      {isLiked ? (
        <Like>
          <img
            src="/img/likedFull.svg"
            alt="좋아요"
            className={`${el.isliked}`}
            onClick={onClickToggleUnLiked}
          />
          {detailPage && <span>좋아요</span>}
          <div className="orange">{likeCount}</div>
        </Like>
      ) : (
        <Like>
          <img
            src="/img/liked.svg"
            alt="좋아요"
            className={`${el.isliked}`}
            onClick={onClickToggleLiked}
          />
          {detailPage && <span>좋아요</span>}
          <div className="black">{likeCount}</div>
        </Like>
      )}
    </>
  );
}

export default LikeToggle;

const Like = styled.div`
  display: flex;

  & img {
    margin: 0;
  }
`;
